
import type { PropType, SetupContext } from 'vue'
import type { DateRange } from '../../models/domain/date-range'
import { defaultLang } from 'keen-ui/src/helpers/date.js'
import { defineComponent } from 'vue'
import { DateUtils } from '../../utils'
import { UiCalendarMonth } from '../keen-ui'
import DateRangePickerCalendarDate from './date-range-picker-calendar-date.component.vue'

export default defineComponent({
  components: {
    UiCalendarMonth,
    DateRangePickerCalendarDate,
  },
  props: {
    date: {
      required: true,
      type: Date as PropType<Date>,
    },
    dateRange: {
      required: true,
      type: Object as PropType<DateRange>,
    },
    allowFutureSelection: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }: SetupContext) {
    function onDateSelect(date: Date): void {
      if (!isDateDisabled(date)) {
        emit('date-select', date)
      }
    }

    function isDateDisabled(date: Date): boolean {
      if (props.allowFutureSelection) {
        return false
      }
      return DateUtils.isFutureDate(date)
    }

    return {
      onDateSelect,
      isDateDisabled,
      defaultLang,
    }
  },
})
